import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_recursos } from "../../config/apiConfig";
import "../../pages/user/css/Empleo.css";

const RecursosDestacados = ({ categoria }) => {

  const [recursos, setRecursos] = useState([]);

  useEffect(() => {
    const fetchRecursos = async () => {
      const selectedCategory = categoria !== "todas" && categoria !== 'destacadas' ? categoria : '';
      const isFeatured = categoria === "destacadas" ? '&isFeatured=true' : '';

      try {
         //const res = await fetch(`${API_recursos}?category=${categoria !=="todas" && categoria !=='destacadas' ? categoria : ''}&isFeatured=${categoria ==='destacadas' }`);
         const res = await fetch(`${API_recursos}?category=${selectedCategory}${isFeatured}`);
        const data = await res.json();

        // Función para normalizar tildes y mayúsculas
        const normalizar = (str) =>
          str?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

        const clasificar = (cat) => {
          const c = normalizar(cat);
          if (["vivienda", "prestaciones", "subvenciones", "social"].includes(c.toLowerCase())) return "Social";
          if (["formacion"].includes(c)) return "Formación";
          if (["empleo"].includes(c)) return "Empleo";
          return "Otros";
        };

        const recursosClasificados = data.map((recurso) => ({
          ...recurso,
          etiqueta: clasificar(recurso.category),
        }));

        let filtrados = recursosClasificados;
        const hoy = new Date();

        if (normalizar(categoria) === "destacadas") {
          filtrados = recursosClasificados.filter((r) => {
            const inicio = r.featuredStart ? new Date(r.featuredStart) : null;
            const fin = r.featuredEnd ? new Date(r.featuredEnd) : null;

            const dentroDelRango = (!inicio || hoy >= inicio) && (!fin || hoy <= fin);
            return r.isFeatured === true && dentroDelRango;
          });
        } else if (normalizar(categoria) !== "todas") {
          filtrados = recursosClasificados.filter(
            (r) => normalizar(r.etiqueta) === normalizar(categoria)
          );
        }

        setRecursos(filtrados);
      } catch (error) {
        console.error("Error al cargar recursos:", error);
      }
    };

    fetchRecursos();
  }, [categoria]);

  // Ruta condicional según categoría
  const getRuta = (recurso) => {
    const normalizada = recurso.category?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    const categoriasSociales = ["vivienda", "prestaciones", "subvenciones", "social"];
    return categoriasSociales.includes(normalizada)
      ? `/recurso-social/${recurso._id}`
      : `/recurso/${recurso._id}`;
  };

  const getClaseColor = (recurso) => {
    const cat = recurso.category?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    if (cat === "empleo") return "verde";
    if (cat === "formacion") return "rosa";
    if (["vivienda", "prestaciones", "subvenciones", "social"].includes(cat)) return "azul";
    return "naranja";
  };

  return (
    <div className="carrusel wrap w-100">
      {recursos.map((recurso) => {
        const claseColor = getClaseColor(recurso);
        return (
          <div key={recurso._id}  className={`recurso ${claseColor}`}>
            <p className={`etiqueta ${claseColor}`}>#{recurso.etiqueta}</p>
            <h2 className="negro mayusculas">{recurso.title}</h2>
            <Link className={claseColor} to={getRuta(recurso)} aria-label="Más información sobre el recurso">Más información</Link>
          </div>
        );
      })}
    </div>         
  );
};

export default RecursosDestacados; 